/* Barlen: de lijst onder het zoekveld. Begrijpt maat, prijs, vorm, materiaal, kleur en "op maat" in een zoekvraag,
   vult zoekwoorden aan, onthoudt de laatste zoekvragen op dit apparaat en is te bedienen met het toetsenbord
   (veld als combobox, lijst als listbox). */
(function () {
  'use strict';

  var COLLECTIE = '/collections/vloerkleden';
  var OP_MAAT = '/collections/vloerkleden-op-maat';
  var SLEUTEL = 'bz-woorden-2';
  var LAATST = 'bz-laatst-1';
  var TELEFOON = window.matchMedia ? window.matchMedia('(max-width: 1000px)') : { matches: false };
  /* Toetsen die de tekst niet veranderen; die starten geen nieuw zoekverzoek. */
  var STIL = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Down', 'Up', 'Left', 'Right', 'Enter', 'Escape', 'Esc', 'Home', 'End', 'PageUp', 'PageDown', 'Tab', 'Shift', 'Control', 'Alt', 'Meta', 'CapsLock'];

  /* Woorden van bezoekers per filterwaarde. De sleutel is de naam van de waarde in het filter, in kleine letters. */
  var WOORDEN = {
    kleur: {
      beige: ['beige', 'zand', 'zandkleur', 'naturel', 'creme', 'ecru'],
      blauw: ['blauw', 'blauwe'],
      bruin: ['bruin', 'bruine', 'cognac', 'terra'],
      gold: ['goud', 'gouden', 'oker'],
      goud: ['goud', 'gouden', 'oker'],
      grijs: ['grijs', 'grijze', 'antraciet', 'grey'],
      groen: ['groen', 'groene', 'olijf', 'salie'],
      rood: ['rood', 'rode'],
      roze: ['roze'],
      silver: ['zilver', 'zilveren'],
      zilver: ['zilver', 'zilveren'],
      veelkleurig: ['veelkleurig', 'veelkleurige', 'bont', 'kleurrijk', 'multicolor'],
      wit: ['wit', 'witte', 'ivoor', 'offwhite']
    },
    vorm: {
      rond: ['rond', 'ronde', 'cirkel'],
      rechthoekig: ['rechthoek', 'rechthoekig', 'rechthoekige'],
      vierkant: ['vierkant', 'vierkante'],
      ovaal: ['ovaal', 'ovale'],
      andere: ['organisch', 'organische', 'grillig', 'grillige']
    },
    materiaal: {
      wol: ['wol', 'wollen', 'scheerwol'],
      katoen: ['katoen', 'katoenen'],
      polyester: ['polyester']
    }
  };
  var NAMEN = { gold: 'Goud', silver: 'Zilver', rechthoekig: 'Rechthoek', andere: 'Organisch' };
  var VULWOORDEN = ['vloerkleed', 'vloerkleden', 'kleed', 'kleden', 'karpet', 'karpetten', 'tapijt', 'tapijten', 'een', 'voor', 'de', 'het', 'met', 'in', 'van', 'en', 'euro', 'eur', 'cm', 'kleur', 'kleuren', 'groot', 'grote', 'maat'];

  var ICO = {
    zoek: '<svg class="bz-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="7" cy="7" r="4.75" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M10.6 10.6l3.4 3.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    klok: '<svg class="bz-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.8V8l2.2 1.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    raster: '<svg class="bz-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><g fill="none" stroke="currentColor" stroke-width="1.4"><rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/></g></svg>',
    pijl: '<svg class="bz-ico bz-ico--pijl" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6 3.5L10.5 8 6 12.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    kruis: '<svg class="bz-x" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };

  var invoer = null, lijst = null, melding = null, woorden = null, bezig = null, laatste = '', teller = 0, stand = null, actief = null, volg = 0, meldKlok = null;

  function schoon(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/€/g, ' euro ').replace(/off[\s-]white/g, 'offwhite').replace(/vrije vorm/g, 'organisch')
      .replace(/(\d)\s*(?:×|\*|bij)\s*(\d)/g, '$1x$2').replace(/(\d)\s*x\s*(\d)/g, '$1x$2')
      .replace(/(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)\s*(?:m|meter)\b/g, function (m, a, b) { return Math.round(parseFloat(a.replace(',', '.')) * 100) + 'x' + Math.round(parseFloat(b.replace(',', '.')) * 100); })
      .replace(/(\d)\s*cm\b/g, '$1').replace(/[^a-z0-9ø.,x\s-]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function afstand1(a, b) {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, fout = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++fout > 1) return false;
      if (a.length === b.length) {
        if (a[i + 1] === b[j] && a[i] === b[j + 1]) { i += 2; j += 2; } else { i++; j++; }
      } else if (a.length > b.length) i++; else j++;
    }
    return fout + (a.length - i) + (b.length - j) <= 1;
  }
  function geld(n) { return '€' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* De woordenlijst uit de filters van de winkel. */
  function bouwWoorden(data) {
    var w = { kleur: [], vorm: [], materiaal: [], maten: [], aantal: data.aantal || 0 };
    (data.filters || []).forEach(function (f) {
      var soort = f.param.indexOf('color-pattern') > -1 ? 'kleur' : f.param.indexOf('rug-shape') > -1 ? 'vorm' : f.param.indexOf('rug-material') > -1 ? 'materiaal' : f.param === 'filter.v.option.maat' ? 'maat' : '';
      if (!soort) return;
      f.waarden.forEach(function (v) {
        var sleutel = schoon(v.label);
        if (soort === 'maat') {
          var m = sleutel.match(/^(\d+)x(\d+)$/), r = v.label.match(/Ø\s*(\d+)/);
          if (m) w.maten.push({ a: Math.min(+m[1], +m[2]), b: Math.max(+m[1], +m[2]), param: f.param, waarde: v.waarde, naam: v.label });
          else if (r) w.maten.push({ d: +r[1], param: f.param, waarde: v.waarde, naam: v.label });
          return;
        }
        var lijstje = (WOORDEN[soort] || {})[sleutel];
        if (!lijstje) return;
        w[soort].push({ woorden: lijstje, param: f.param, waarde: v.waarde, naam: NAMEN[sleutel] || v.label });
      });
    });
    return w;
  }
  function haalWoorden() {
    if (woorden) return Promise.resolve(woorden);
    try { var op = JSON.parse(sessionStorage.getItem(SLEUTEL) || 'null'); if (op && op.kleur) { woorden = op; return Promise.resolve(woorden); } } catch (e) {}
    if (bezig) return bezig;
    bezig = haal(COLLECTIE + '?section_id=barlen-zoekdata', 3).then(function (data) {
      bezig = null;
      var w = bouwWoorden(data || {});
      /* Een lege lijst (het ophalen mislukte) wordt niet bewaard; bij de volgende toets volgt een nieuwe poging. */
      if (w.kleur.length || w.maten.length) {
        woorden = w;
        try { sessionStorage.setItem(SLEUTEL, JSON.stringify(w)); } catch (e) {}
      }
      return w;
    });
    return bezig;
  }
  function haal(adres, pogingen) {
    return fetch(adres, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); }).then(function (html) {
      var m = html.match(/<script type="application\/json" data-bz-data>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('leeg');
      return JSON.parse(m[1]);
    }).catch(function (e) {
      if (pogingen > 1) return new Promise(function (ok) { setTimeout(ok, 500); }).then(function () { return haal(adres, pogingen - 1); });
      return null;
    });
  }

  /* Een zoekvraag uitlezen. Geeft de herkende eigenschappen en wat er overblijft. */
  function lees(ruw, w) {
    var t = ' ' + schoon(ruw) + ' ';
    var uit = { knopjes: [], params: [], opMaat: false, rest: '', maat: null };
    var neem = function (re, fn) { t = t.replace(re, function () { var r = fn.apply(null, arguments); return r === false ? arguments[0] : ' '; }); };

    neem(/ tussen(?: euro)? (\d{2,6}) en(?: euro)? (\d{2,6})(?: euro)? /, function (m, a, b) { uit.knopjes.push({ naam: geld(+a) + ' tot ' + geld(+b), tekst: m.trim() }); uit.params.push(['filter.v.price.gte', a], ['filter.v.price.lte', b]); });
    neem(/ (?:onder|tot|max|maximaal|goedkoper dan|hoogstens)(?: de)?(?: euro)? (\d{2,6})(?: euro)? /, function (m, a) { uit.knopjes.push({ naam: 'tot ' + geld(+a), tekst: m.trim() }); uit.params.push(['filter.v.price.lte', a]); });
    neem(/ (?:vanaf|boven|minimaal|minstens)(?: de)?(?: euro)? (\d{2,6})(?: euro)? /, function (m, a) { uit.knopjes.push({ naam: 'vanaf ' + geld(+a), tekst: m.trim() }); uit.params.push(['filter.v.price.gte', a]); });
    neem(/ (?:op maat|maatwerk|eigen maat|afwijkende maat) /, function (m) { uit.opMaat = true; uit.knopjes.push({ naam: 'Op maat', tekst: m.trim() }); });
    neem(/ (?:rond|ronde|ø|diameter) ?(\d{2,3}) /, function (m, d) {
      var gevonden = w.maten.filter(function (x) { return x.d === +d; })[0];
      uit.maat = { rond: true, d: +d, bestaat: !!gevonden };
      uit.knopjes.push({ naam: 'Ø ' + d + ' cm', tekst: m.trim(), los: !gevonden });
      if (gevonden) uit.params.push([gevonden.param, gevonden.waarde]);
      var rond = w.vorm.filter(function (x) { return x.woorden.indexOf('rond') > -1; })[0];
      if (rond) { uit.knopjes.unshift({ naam: rond.naam, tekst: '' }); uit.params.push([rond.param, rond.waarde]); }
    });
    neem(/ (\d{2,3})x(\d{2,3}) /, function (m, a, b) {
      var k = Math.min(+a, +b), g = Math.max(+a, +b);
      var gevonden = w.maten.filter(function (x) { return x.a === k && x.b === g; })[0];
      uit.maat = { rond: false, b: +a, l: +b, bestaat: !!gevonden };
      uit.knopjes.push({ naam: (gevonden ? gevonden.naam : a + ' × ' + b + ' cm'), tekst: m.trim(), los: !gevonden });
      if (gevonden) uit.params.push([gevonden.param, gevonden.waarde]);
    });

    var over = [];
    t.trim().split(' ').forEach(function (woord) {
      if (!woord) return;
      if (VULWOORDEN.indexOf(woord) > -1) return;
      var raak = null;
      ['vorm', 'materiaal', 'kleur'].some(function (soort) {
        return w[soort].some(function (v) {
          var ok = v.woorden.indexOf(woord) > -1 || (woord.length >= 5 && v.woorden.some(function (x) { return x.length >= 5 && afstand1(woord, x); }));
          if (ok) raak = v;
          return ok;
        });
      });
      if (raak) {
        if (!uit.params.some(function (p) { return p[0] === raak.param && p[1] === raak.waarde; })) { uit.knopjes.push({ naam: raak.naam, tekst: woord }); uit.params.push([raak.param, raak.waarde]); }
      } else over.push(woord);
    });
    uit.rest = over.join(' ');
    return uit;
  }
  function adresVan(u) {
    var basis = u.opMaat ? OP_MAAT : COLLECTIE;
    var q = u.params.map(function (p) { return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]); });
    if (u.maat && !u.maat.bestaat) q.push(u.maat.rond ? 'd=' + u.maat.d : 'b=' + u.maat.b + '&l=' + u.maat.l);
    return basis + (q.length ? '?' + q.join('&') : '');
  }
  /* Hetzelfde adres in de collectie op maat. "/collections/vloerkleden-op-maat" begint zelf met
     "/collections/vloerkleden"; een adres dat al op maat is, blijft daarom zoals het is. */
  function opMaatAdres(adres) {
    return adres.indexOf(OP_MAAT) === 0 ? adres : adres.replace(COLLECTIE, OP_MAAT);
  }

  /* Zoekwoorden vanaf twee letters: woorden uit de eigen lijst die beginnen met wat er getypt is. Alleen woorden
     waarvan de filterwaarde in de winkel bestaat; kiezen geeft dus altijd knopjes met kleden. */
  function zoekwoorden(ruw, w) {
    var t = schoon(ruw);
    if (t.length < 2 || !w) return [];
    var uit = [];
    ['vorm', 'materiaal', 'kleur'].forEach(function (soort) {
      (w[soort] || []).forEach(function (v) {
        if (uit.some(function (u) { return u.naam === v.naam; })) return;
        var woord = v.woorden.filter(function (x) { return x.indexOf(t) === 0 && x !== t; })[0];
        if (woord) uit.push({ woord: woord, naam: v.naam, soort: soort });
      });
    });
    if ('op maat'.indexOf(t) === 0 && t !== 'op maat') uit.push({ woord: 'op maat', naam: 'Op maat', soort: '' });
    else if ('maatwerk'.indexOf(t) === 0 && t !== 'maatwerk') uit.push({ woord: 'maatwerk', naam: 'Op maat', soort: '' });
    uit.forEach(function (z) { z.adres = adresVan(lees(z.woord, w)); });
    return uit;
  }
  /* Het aangevulde deel vet: de bezoeker kent de letters die hij zelf typte al. */
  function aangevuld(woord, ruw) {
    var t = schoon(ruw);
    return woord.indexOf(t) === 0 ? esc(woord.slice(0, t.length)) + '<b>' + esc(woord.slice(t.length)) + '</b>' : '<b>' + esc(woord) + '</b>';
  }

  /* Regels en groepen, in dezelfde opmaak als de lijst uit de sectie. */
  function groep(sleutel, kop, binnen) {
    var id = 'bz-k-' + sleutel;
    return '<div class="bz-groep" role="group" aria-labelledby="' + id + '" data-bz-groep="' + sleutel + '"><p class="bz-kop" id="' + id + '" role="presentation">' + esc(kop) + '</p>' + binnen + '</div>';
  }
  function woordRij(z, ruw) {
    var rechts = z.woord.toLowerCase() === z.naam.toLowerCase() ? z.soort : z.naam;
    return '<a class="bz-rij bz-rij--woord" role="option" href="' + esc(z.adres) + '" data-bz-woord="' + esc(z.woord) + '">' + ICO.zoek + '<span class="bz-woord">' + aangevuld(z.woord, ruw) + '</span> <span class="bz-soort">' + esc(rechts) + '</span></a>';
  }
  function linkRij(href, ico, tekst, soort) {
    return '<a class="bz-rij bz-rij--link" role="option" href="' + esc(href) + '">' + ico + '<span class="bz-label">' + esc(tekst) + '</span> <span class="bz-soort">' + esc(soort || '') + '</span></a>';
  }
  function laatstRij(t) {
    return '<a class="bz-rij bz-rij--link bz-rij--laatst" role="option" href="/search?q=' + encodeURIComponent(t) + '" data-bz-laatst="' + esc(t) + '">' + ICO.klok + '<span class="bz-label">' + esc(t) + '</span> <span class="bz-weg" data-bz-wis="' + esc(t) + '" title="Weghalen" aria-hidden="true">' + ICO.kruis + '</span></a>';
  }
  function allesRij(href, tekst, stil) {
    return '<a class="bz-rij bz-rij--alles' + (stil ? ' bz-rij--stil bz-letterlijk' : '') + '" role="option" href="' + esc(href) + '"' + (stil ? '' : ' data-bz-alles') + '><span class="bz-label">' + esc(tekst) + '</span>' + ICO.pijl + '</a>';
  }
  function samenRij(href, links, knop) {
    return '<a class="bz-rij bz-rij--samen bz-bekijk" role="option" href="' + esc(href) + '"><span class="bz-uitkomst">' + links + '</span> <span class="bz-knop">' + esc(knop) + '</span></a>';
  }
  function nummer(binnen) {
    [].forEach.call((binnen || lijst).querySelectorAll('[role="option"]'), function (o) { if (!o.id) o.id = 'bz-o-' + (++volg); });
  }

  /* Laatst gezocht: hoogstens drie zoekvragen, alleen op dit apparaat. */
  function leesLaatst() {
    try { var l = JSON.parse(localStorage.getItem(LAATST) || '[]'); return Array.isArray(l) ? l.filter(function (x) { return typeof x === 'string' && x; }).slice(0, 3) : []; } catch (e) { return []; }
  }
  function bewaarLaatst(t) {
    t = (t || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    if (t.length < 2) return;
    var l = leesLaatst().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
    l.unshift(t);
    try { localStorage.setItem(LAATST, JSON.stringify(l.slice(0, 3))); } catch (e) {}
  }
  function wisLaatst(t) {
    var l = leesLaatst().filter(function (x) { return x !== t; });
    try { localStorage.setItem(LAATST, JSON.stringify(l)); } catch (e) {}
    wijs(null);
    leegStand();
    zetOpen();
  }

  /* De lege stand: "Veel gezocht" (uit de kop), "Laatst gezocht" en één regel uitleg. */
  function leegStand() {
    var ph = lijst.querySelector('.search-placeholders');
    if (!ph) return;
    var lb = ph.querySelector('#bz-lijst-leeg');
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'bz-lijst';
      lb.id = 'bz-lijst-leeg';
      lb.setAttribute('role', 'listbox');
      lb.setAttribute('aria-label', 'Zoeksuggesties');
      var veel = ph.querySelector('.bz-veel');
      ph.insertBefore(lb, veel || ph.firstChild);
      if (veel) {
        lb.appendChild(veel);
        veel.setAttribute('role', 'group');
        var kop = veel.querySelector('p.strong');
        if (kop) { kop.id = 'bz-k-veel'; kop.setAttribute('role', 'presentation'); kop.classList.add('bz-kop'); veel.setAttribute('aria-labelledby', 'bz-k-veel'); }
        [].forEach.call(veel.querySelectorAll('ul, li'), function (x) { x.setAttribute('role', 'none'); });
        [].forEach.call(veel.querySelectorAll('a'), function (a) { a.setAttribute('role', 'option'); });
      }
      var uitleg = document.createElement('p');
      uitleg.className = 'bz-hint';
      uitleg.textContent = 'Typ gewoon wat je zoekt, bijvoorbeeld: rond wollen kleed beige';
      ph.appendChild(uitleg);
    }
    var oud = lb.querySelector('[data-bz-groep="laatst"]');
    if (oud) oud.parentNode.removeChild(oud);
    var l = leesLaatst();
    if (l.length) lb.insertAdjacentHTML('beforeend', groep('laatst', 'Laatst gezocht', l.map(laatstRij).join('')));
    nummer(lb);
  }

  /* De lijst uit de sectie aanvullen: zoekwoorden bovenaan, per scherm afkappen, één melding. */
  function versier() {
    var lb = lijst.querySelector('#bz-lijst');
    if (!lb || lb.hasAttribute('data-bz-klaar')) return;
    lb.setAttribute('data-bz-klaar', '');
    wijs(null);
    var term = lb.getAttribute('data-bz-term') || '';
    var af = function (w) {
      if (!lb.isConnected) return;
      var z = zoekwoorden(term, w);
      if (z.length) {
        var rijen = z.map(function (x) { return woordRij(x, term); }).join('');
        var niets = lb.closest('.bz-niets');
        var g = lb.querySelector('[data-bz-groep="woorden"]');
        if (niets) {
          /* Geen kleden, wel zoekwoorden ("ro" wordt rond, rood of roze): de hulp bij geen treffers wijkt. */
          var hulp = lb.querySelector('[data-bz-groep="hulp"]');
          var nieuw = document.createElement('div');
          nieuw.className = 'bz-lijst';
          nieuw.id = 'bz-lijst';
          nieuw.setAttribute('role', 'listbox');
          nieuw.setAttribute('aria-label', 'Zoeksuggesties');
          nieuw.setAttribute('data-bz-term', term);
          nieuw.setAttribute('data-bz-klaar', '');
          nieuw.innerHTML = groep('woorden', 'Zoekwoorden', rijen) + (hulp ? hulp.outerHTML : '') + allesRij('/search?q=' + encodeURIComponent(term), 'Alle resultaten voor "' + term + '"');
          niets.parentNode.replaceChild(nieuw, niets);
          lb = nieuw;
        } else if (g) {
          g.querySelector('.bz-kop').insertAdjacentHTML('afterend', rijen);
        } else {
          lb.insertAdjacentHTML('afterbegin', groep('woorden', 'Zoekwoorden', rijen));
        }
      }
      var aantal = lb.querySelector('[data-bz-aantal]');
      if (aantal && w && w.aantal) aantal.textContent = w.aantal + ' kleden';
      nummer(lb);
      knip();
      meldLijst(lb, term);
      zetOpen();
    };
    /* Meteen afkappen en nummeren; de zoekwoorden en de ene melding volgen zodra de woordenlijst er is. */
    nummer(lb);
    knip();
    if (woorden) af(woorden);
    else haalWoorden().then(function (w) { af(w && (w.kleur.length || w.maten.length) ? w : null); });
  }
  /* Hoogstens 10 regels op groot scherm en 8 op de telefoon: 3 zoekwoorden, 2 collecties (telefoon 1), 4 kleden en de
     laatste regel; is de lijst op de telefoon vol, dan 2 zoekwoorden. Hulp en advies alleen als er ruimte over is. */
  function knip() {
    var lb = lijst.querySelector('#bz-lijst');
    if (!lb || lb.closest('.bz-niets')) return;
    var max = TELEFOON.matches ? 8 : 10;
    var groepEl = function (g) { return lb.querySelector('[data-bz-groep="' + g + '"]'); };
    var r = {};
    ['woorden', 'collecties', 'kleden', 'hulp'].forEach(function (g) { var el = groepEl(g); r[g] = el ? [].slice.call(el.querySelectorAll('[role="option"]')) : []; });
    var n = { woorden: Math.min(3, r.woorden.length), collecties: Math.min(TELEFOON.matches ? 1 : 2, r.collecties.length), kleden: Math.min(4, r.kleden.length) };
    var alles = lb.querySelector('[data-bz-alles]') ? 1 : 0;
    var som = function () { return n.woorden + n.collecties + n.kleden + alles; };
    if (som() > max && n.woorden > 2) n.woorden = 2;
    if (som() > max && n.collecties > 1) n.collecties = 1;
    while (som() > max && n.woorden > 0) n.woorden--;
    n.hulp = Math.max(0, Math.min(2, r.hulp.length, max - som()));
    Object.keys(r).forEach(function (g) {
      r[g].forEach(function (o, i) { o.hidden = i >= n[g]; });
      var el = groepEl(g);
      if (el) el.hidden = n[g] === 0;
    });
    if (actief && !zichtbaar(actief)) wijs(null);
  }

  /* Eén melding voor een schermlezer na elke nieuwe lijst. */
  function meld(t) {
    if (!melding) return;
    clearTimeout(meldKlok);
    melding.textContent = '';
    meldKlok = setTimeout(function () { melding.textContent = t; }, 300);
  }
  function meldLijst(lb, term) {
    /* Staat het blok met knopjes in beeld, dan meldt dat blok; de gewone lijst eronder is dan verborgen. */
    if (lijst.classList.contains('bz-aan')) return;
    if (lb.closest('.bz-niets')) { meld('Geen kleden voor "' + term + '". Gebruik pijl omlaag voor andere ingangen.'); return; }
    var tel = function (g) { var el = lb.querySelector('[data-bz-groep="' + g + '"]'); return el ? [].filter.call(el.querySelectorAll('[role="option"]'), function (o) { return !o.hidden; }).length : 0; };
    var k = tel('kleden'), z = tel('woorden'), c = tel('collecties'), delen = [];
    if (k) delen.push(k + (k === 1 ? ' kleed' : ' kleden'));
    if (z) delen.push(z + (z === 1 ? ' zoekwoord' : ' zoekwoorden'));
    if (c) delen.push(c + (c === 1 ? ' collectie' : ' collecties'));
    meld((delen.length ? delen.join(', ') : 'Resultaten') + '. Gebruik pijl omlaag om te kiezen.');
  }

  /* Het blok met begrepen eigenschappen bovenaan de lijst: knopjes, aantal, kleden, letterlijk zoeken. */
  function blok() {
    var el = lijst.querySelector('[data-bz-begrip]');
    if (!el) { el = document.createElement('div'); el.className = 'bz-begrip'; el.setAttribute('data-bz-begrip', ''); }
    if (lijst.firstElementChild !== el) lijst.insertBefore(el, lijst.firstChild);
    return el;
  }
  function weg() {
    if (!lijst) return;
    lijst.classList.remove('bz-aan');
    var el = lijst.querySelector('[data-bz-begrip]');
    if (el) el.remove();
    delete invoer.form.dataset.bzAdres;
  }
  function toon(u, data, ruw) {
    var el = blok();
    var adres = adresVan(u);
    var maatwerk = u.maat && !u.maat.bestaat;
    var maatTekst = u.maat ? (u.maat.rond ? 'Ø ' + u.maat.d + ' cm' : u.maat.b + ' × ' + u.maat.l + ' cm') : '';
    var html = '<div class="bz-knopjes">' + u.knopjes.map(function (k, i) {
      return '<button type="button" class="bz-knopje' + (k.los ? ' bz-knopje--los' : '') + '" data-bz-weg="' + i + '" aria-label="' + esc(k.naam) + ' weghalen">' + esc(k.naam) + ICO.kruis + '</button>';
    }).join('') + '</div>';
    var voor = '', rijen = '', tekst = '';
    if (maatwerk) {
      rijen = samenRij(opMaatAdres(adres), '<strong>' + esc(maatTekst) + ' is geen vaste maat</strong>', 'Op maat laten maken in ' + maatTekst);
      tekst = maatTekst + ' is geen vaste maat; op maat laten maken kan wel.';
    } else if (!data) {
      voor = '<p class="bz-uitkomst bz-uitkomst--laden">Kleden zoeken…</p>';
    } else if (data.onbekend) {
      rijen = samenRij(adres, '<strong>Kleden met deze keuze</strong>', 'Bekijk de kleden');
    } else if (data.aantal) {
      rijen = samenRij(adres, '<strong>' + data.aantal + (data.aantal === 1 ? ' kleed' : ' kleden') + '</strong>' + (data.maat ? ' <span class="bz-zacht">in ' + esc(data.maat) + '</span>' : ''), 'Bekijk ze');
      rijen += groep('b-kleden', 'Kleden', (data.kleden || []).map(function (k) { return k.html || ''; }).join(''));
      tekst = data.aantal + (data.aantal === 1 ? ' kleed' : ' kleden') + ' gevonden voor ' + u.knopjes.map(function (k) { return k.naam.toLowerCase(); }).join(', ') + '.';
    } else {
      voor = '<p class="bz-uitkomst"><strong>0 kleden</strong></p><p class="bz-leeg">Haal een knopje weg voor meer kleden.</p>';
      rijen = linkRij(OP_MAAT, ICO.raster, 'Laat een kleed op maat maken', '');
      tekst = 'Geen kleden met deze keuze.';
    }
    rijen += allesRij('/search?q=' + encodeURIComponent(ruw), 'Zoek letterlijk op "' + ruw + '"', true);
    html += voor + '<div class="bz-lijst" id="bz-lijst-begrip" role="listbox" aria-label="Zoeksuggesties">' + rijen + '</div>';
    wijs(null);
    el.innerHTML = html;
    el.querySelectorAll('[data-bz-weg]').forEach(function (knop) {
      knop.addEventListener('click', function (e) {
        e.preventDefault();
        var k = u.knopjes[+knop.getAttribute('data-bz-weg')];
        var nu = ' ' + schoon(invoer.value) + ' ';
        if (k.tekst) nu = nu.replace(' ' + k.tekst + ' ', ' ');
        else nu = nu.replace(/ (rond|ronde|ø|diameter) /, ' ');
        invoer.value = nu.replace(/\s+/g, ' ').trim();
        invoer.dispatchEvent(new Event('input', { bubbles: true }));
        invoer.focus();
      });
    });
    nummer(el);
    lijst.classList.add('bz-aan');
    invoer.form.dataset.bzAdres = maatwerk ? opMaatAdres(adres) : adres;
    if (tekst) meld(tekst + ' Gebruik pijl omlaag om te kiezen.');
    zetOpen();
  }

  function verwerk() {
    var ruw = invoer.value.trim();
    if (ruw === laatste && lijst.querySelector('[data-bz-begrip]')) return;
    laatste = ruw;
    var mijn = ++teller;
    if (ruw.length < 3) { weg(); return; }
    haalWoorden().then(function (w) {
      if (mijn !== teller) return;
      if (!w.kleur.length && !w.maten.length) { weg(); laatste = ''; return; }
      var u = lees(ruw, w);
      /* Alleen overnemen als de hele vraag begrepen is; een modelnaam of ander woord gaat naar de gewone lijst. */
      if (!u.knopjes.length || u.rest) { weg(); return; }
      stand = { ruw: ruw, u: u, data: null };
      toon(u, null, ruw);
      if (u.maat && !u.maat.bestaat) return;
      var adres = adresVan(u);
      /* Pas ophalen als er 300 ms niet getypt is (zoals de lijst van het thema), niet bij elke letter. */
      setTimeout(function () {
        if (mijn !== teller) return;
        haal(adres + (adres.indexOf('?') > -1 ? '&' : '?') + 'section_id=barlen-zoekdata', 4).then(function (data) {
          if (mijn !== teller) return;
          stand = { ruw: ruw, u: u, data: data || { onbekend: true, aantal: 0, kleden: [] } };
          toon(u, stand.data, ruw);
        });
      }, 300);
    });
  }

  /* Toetsenbord: pijltjes wijzen een regel aan (de focus blijft in het veld), Enter opent hem, Escape sluit de lijst
     en laat de tekst staan. */
  function zichtbaar(o) { return !!o && o.isConnected && o.getClientRects().length > 0; }
  function open() { return !!lijst && lijst.getClientRects().length > 0 && !!lijst.firstElementChild; }
  function opties() { return [].filter.call(lijst.querySelectorAll('[role="option"]'), zichtbaar); }
  function wijs(o, zonderScroll) {
    if (actief && actief !== o) actief.removeAttribute('aria-selected');
    actief = o || null;
    if (!invoer) return;
    if (o) {
      if (!o.id) o.id = 'bz-o-' + (++volg);
      o.setAttribute('aria-selected', 'true');
      invoer.setAttribute('aria-activedescendant', o.id);
      if (!zonderScroll && o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    } else {
      invoer.removeAttribute('aria-activedescendant');
    }
  }
  function zetOpen() {
    if (!invoer) return;
    var o = open();
    invoer.setAttribute('aria-expanded', o ? 'true' : 'false');
    var lb = o ? [].filter.call(lijst.querySelectorAll('[role="listbox"]'), zichtbaar)[0] : null;
    invoer.setAttribute('aria-controls', lb && lb.id ? lb.id : 'livesearch');
    if (!o && actief) wijs(null);
  }
  function sluit() {
    wijs(null);
    invoer.form.classList.remove('full', 'has-text', 'not-empty');
    document.documentElement.classList.remove('search-full', 'search-full-mode');
    zetOpen();
  }
  function heropen() {
    if (!lijst.firstElementChild) return false;
    invoer.form.classList.add('full', 'has-text');
    if (invoer.value) invoer.form.classList.add('not-empty');
    document.documentElement.classList.add('search-full', 'search-full-mode');
    zetOpen();
    return open();
  }
  function neem(t) {
    invoer.value = t;
    invoer.focus();
    try { invoer.setSelectionRange(t.length, t.length); } catch (e) {}
    wijs(null);
    invoer.dispatchEvent(new Event('input', { bubbles: true }));
    var ku;
    try { ku = new KeyboardEvent('keyup', { bubbles: true, key: 'Unidentified' }); } catch (e) { ku = document.createEvent('Event'); ku.initEvent('keyup', true, true); }
    invoer.dispatchEvent(ku);
  }
  function kies(o) {
    var w = o.getAttribute('data-bz-woord') || o.getAttribute('data-bz-laatst');
    if (w) { neem(w); return; }
    o.click();
  }
  function toets(e) {
    if (e.isComposing) return;
    var k = e.key;
    if (k === 'ArrowDown' || k === 'Down' || k === 'ArrowUp' || k === 'Up') {
      if (!open() && !heropen()) return;
      var os = opties();
      if (!os.length) return;
      e.preventDefault();
      var i = os.indexOf(actief), omlaag = k === 'ArrowDown' || k === 'Down';
      wijs(os[omlaag ? (i < 0 || i === os.length - 1 ? 0 : i + 1) : (i <= 0 ? os.length - 1 : i - 1)]);
    } else if (k === 'Enter') {
      if (actief && zichtbaar(actief) && open()) { e.preventDefault(); e.stopPropagation(); kies(actief); }
    } else if (k === 'Escape' || k === 'Esc') {
      /* Eerste Escape: lijst dicht, tekst blijft. Is de lijst al dicht, dan wist de volgende Escape zoals voorheen. */
      if (open()) { e.preventDefault(); e.stopPropagation(); sluit(); }
    } else if ((k === 'Delete' || k === 'Del') && actief && actief.hasAttribute('data-bz-laatst') && open()) {
      e.preventDefault();
      wisLaatst(actief.getAttribute('data-bz-laatst'));
    } else if (k === 'ArrowLeft' || k === 'ArrowRight' || k === 'Left' || k === 'Right' || k === 'Home' || k === 'End') {
      wijs(null);
    }
  }
  function klik(e) {
    var doel = e.target && e.target.closest ? e.target : null;
    if (!doel) return;
    var wis = doel.closest('[data-bz-wis]');
    if (wis && lijst.contains(wis)) { e.preventDefault(); e.stopPropagation(); wisLaatst(wis.getAttribute('data-bz-wis')); invoer.focus(); return; }
    var o = doel.closest('[data-bz-woord], [data-bz-laatst]');
    if (o && lijst.contains(o) && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) { e.preventDefault(); neem(o.getAttribute('data-bz-woord') || o.getAttribute('data-bz-laatst')); return; }
    var a = doel.closest('a[href]');
    if (a && lijst.contains(a) && !a.hasAttribute('data-search-suggestion')) bewaarLaatst(invoer.value);
  }
  function zweef(e) {
    var o = e.target && e.target.closest ? e.target.closest('[role="option"]') : null;
    if (o && o !== actief && lijst.contains(o)) wijs(o, true);
  }

  function start() {
    invoer = document.getElementById('search_main');
    lijst = document.getElementById('livesearch');
    if (!invoer || !lijst || !invoer.form || invoer.dataset.bz) return;
    invoer.dataset.bz = '1';
    invoer.setAttribute('role', 'combobox');
    invoer.setAttribute('aria-autocomplete', 'list');
    invoer.setAttribute('aria-expanded', 'false');
    invoer.setAttribute('aria-controls', 'livesearch');
    melding = document.createElement('p');
    melding.className = 'bz-sr';
    melding.setAttribute('aria-live', 'polite');
    melding.setAttribute('aria-atomic', 'true');
    melding.setAttribute('data-bz-melding', '');
    invoer.form.appendChild(melding);
    invoer.addEventListener('focus', function () { haalWoorden(); if (invoer.value.trim().length >= 3) verwerk(); });
    invoer.addEventListener('input', function () { wijs(null); verwerk(); });
    invoer.addEventListener('keydown', toets);
    /* Toetsen die de tekst niet veranderen, gaan niet door naar het zoeken bij elke toets. */
    invoer.form.addEventListener('keyup', function (e) { if (e.target === invoer && STIL.indexOf(e.key) > -1) e.stopPropagation(); }, true);
    lijst.addEventListener('click', klik);
    lijst.addEventListener('mousemove', zweef);
    /* De lijst wordt bij elk antwoord opnieuw gevuld: blok terug bovenaan, zoekwoorden erbij, rollen bijwerken. */
    new MutationObserver(function () {
      if (actief && !actief.isConnected) wijs(null);
      if (lijst.classList.contains('bz-aan') && !lijst.querySelector('[data-bz-begrip]')) {
        if (stand && stand.ruw === invoer.value.trim()) toon(stand.u, stand.data, stand.ruw); else { laatste = ''; verwerk(); }
      }
      versier();
      leegStand();
      zetOpen();
    }).observe(lijst, { childList: true });
    new MutationObserver(zetOpen).observe(invoer.form, { attributes: true, attributeFilter: ['class'] });
    invoer.form.addEventListener('submit', function (e) {
      bewaarLaatst(invoer.value);
      var adres = invoer.form.dataset.bzAdres;
      if (adres && lijst.classList.contains('bz-aan')) { e.preventDefault(); e.stopPropagation(); window.location.href = adres; }
    }, true);
    if (TELEFOON.addEventListener) TELEFOON.addEventListener('change', knip); else if (TELEFOON.addListener) TELEFOON.addListener(knip);
    leegStand();
    versier();
    zetOpen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('search', function () { setTimeout(start, 0); });
})();
